// AUTO-GENERATED from redesign-concept/index.html — the approved GlobalNow landing.
export const GN_CSS = `
  /* ============================================================
     GlobalNow.biz — REDESIGN CONCEPT (self-contained prototype)
     Aesthetic echoes aisuperhub.dev: near-black navy canvas,
     indigo→violet accent, green "go" CTA, Inter, gradient text,
     glow, glass cards. Dark-first, with a light-mode fallback.
     ============================================================ */
  :root {
    --bg-primary:   #07080f;
    --bg-secondary: #0d1117;
    --bg-card:      #111827;
    --bg-card-hover:#1a2332;
    --border:       #1e293b;
    --border-accent:#312e81;
    --text-primary: #e2e8f0;
    --text-secondary:#94a3b8;
    --text-muted:   #64748b;
    --accent:       #6366f1;
    --accent-light: #818cf8;
    --accent-deep:  #4f46e5;
    --accent-glow:  rgba(99,102,241,0.15);
    --green:        #22c55e;
    --green-light:  #4ade80;
    --green-deep:   #16a34a;
    --radius:       18px;
    --maxw:         1120px;
    --font: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  }

  * { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; -webkit-text-size-adjust: 100%; }
  body {
    font-family: var(--font);
    background: var(--bg-primary);
    color: var(--text-primary);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }
  a { color: inherit; text-decoration: none; }
  img { max-width: 100%; display: block; }
  .wrap { max-width: var(--maxw); margin: 0 auto; padding: 0 24px; }
  section { position: relative; }

  h1,h2,h3 { line-height: 1.12; letter-spacing: -0.02em; font-weight: 800; }
  .grad-text {
    background: linear-gradient(135deg,#e2e8f0 0%, #818cf8 50%, #6366f1 100%);
    -webkit-background-clip: text; background-clip: text; color: transparent;
  }
  .green-text { color: var(--green-light); }

  /* ---------- Buttons ---------- */
  .btn {
    display: inline-flex; align-items: center; gap: 9px;
    font-weight: 700; font-size: 1.02rem; border: none; cursor: pointer;
    padding: 15px 28px; border-radius: 14px; transition: all .25s ease;
    white-space: nowrap;
  }
  .btn-primary {
    background: linear-gradient(135deg,#22c55e,#16a34a);
    color: #04140a;
    box-shadow: 0 8px 30px rgba(34,197,94,0.32);
  }
  .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(34,197,94,0.5); }
  .btn-ghost {
    background: transparent; color: var(--accent-light);
    border: 1.5px solid var(--accent); padding: 13.5px 26px;
  }
  .btn-ghost:hover { background: var(--accent-glow); border-color: var(--accent-light); }
  .btn-sm { padding: 10px 18px; font-size: .92rem; border-radius: 11px; }

  /* ---------- Pill / badge ---------- */
  .pill {
    display: inline-flex; align-items: center; gap: 8px;
    font-size: .82rem; font-weight: 700; letter-spacing: .01em;
    padding: 7px 15px; border-radius: 999px;
  }
  .pill-green { background: rgba(34,197,94,0.1); border: 1px solid rgba(34,197,94,0.32); color: var(--green-light); }
  .pill-indigo { background: var(--accent-glow); border: 1px solid var(--border-accent); color: var(--accent-light); }
  .dot { width: 7px; height: 7px; border-radius: 50%; background: var(--green-light); box-shadow: 0 0 10px var(--green-light); }

  /* ---------- Nav ---------- */
  header {
    position: sticky; top: 0; z-index: 50;
    background: rgba(7,8,15,0.72); backdrop-filter: blur(14px);
    border-bottom: 1px solid var(--border);
  }
  .topbar {
    background: linear-gradient(90deg,var(--accent-deep),var(--accent));
    color: #eef2ff; text-align: center; font-size: .82rem; font-weight: 600;
    padding: 7px 12px;
  }
  nav { display: flex; align-items: center; justify-content: space-between; height: 66px; }
  .logo { display: flex; align-items: center; gap: 10px; font-weight: 800; font-size: 1.18rem; letter-spacing: -0.02em; }
  .logo .mark {
    width: 30px; height: 30px; border-radius: 9px;
    background: linear-gradient(135deg,var(--accent-light),var(--accent-deep));
    display: grid; place-items: center; font-size: 1rem; color: #fff; box-shadow: 0 0 18px var(--accent-glow);
  }
  .nav-links { display: flex; align-items: center; gap: 26px; }
  .nav-links a { color: var(--text-secondary); font-size: .95rem; font-weight: 500; transition: color .2s; }
  .nav-links a:hover { color: var(--text-primary); }
  /* 2026-09-18 conversion audit: ".nav-links a" (class+tag) outranks ".btn-primary"
     (class only), so the header "Build my site → $199" button was silently losing its
     near-black button text and rendering --text-secondary gray instead — on the green
     gradient that measured ~1.06:1 contrast (WCAG fail; every other .btn-primary on the
     page measures ~6.9:1). Restoring it here without touching the shared .btn-primary rule
     that already works correctly everywhere else on the page. */
  .nav-links a.btn-primary, .nav-links a.btn-primary:hover { color: #04140a; }
  .nav-phone { color: var(--text-primary); font-weight: 700; font-size: .95rem; }
  .nav-phone span { color: var(--text-muted); font-weight: 500; }

  /* ---------- Hero ---------- */
  .hero { padding: 90px 0 70px; text-align: center; overflow: hidden; }
  .hero::before, .hero::after {
    content:""; position: absolute; border-radius: 50%; filter: blur(90px); z-index: 0;
  }
  .hero::before { width: 520px; height: 520px; background: rgba(99,102,241,0.18); top: -140px; left: 50%; transform: translateX(-55%); }
  .hero::after  { width: 380px; height: 380px; background: rgba(34,197,94,0.10); bottom: -160px; right: -60px; }
  .hero .wrap { position: relative; z-index: 1; }
  .hero h1 { font-size: clamp(2.5rem, 6vw, 4.2rem); margin: 22px 0 20px; }
  .hero .sub {
    font-size: clamp(1.05rem, 2.3vw, 1.35rem); color: var(--text-secondary);
    max-width: 680px; margin: 0 auto 14px;
  }
  .hero .price-line { font-size: clamp(1.2rem,2.6vw,1.6rem); color: var(--text-primary); font-weight: 700; margin-bottom: 30px; }
  .hero .price-line b { color: #fff; }
  .cta-row { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; margin-bottom: 18px; }
  .microtrust { color: var(--text-muted); font-size: .92rem; }
  .microtrust a { color: var(--accent-light); font-weight: 700; }

  /* ---------- Hero promo video ---------- */
  .hero-video-wrap {
    max-width: 360px; margin: 0 auto 28px; border-radius: 22px; overflow: hidden;
    border: 1px solid var(--border-accent); box-shadow: 0 20px 60px rgba(0,0,0,0.45);
    position: relative; background: var(--bg-secondary);
  }
  .hero-video-wrap video { width: 100%; display: block; aspect-ratio: 16/9; object-fit: cover; }
  .hero-video-badge {
    position: absolute; top: 10px; left: 10px; background: rgba(7,8,15,0.72); backdrop-filter: blur(6px);
    color: #fff; font-size: .74rem; font-weight: 700; padding: 5px 10px; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
  }

  /* ---------- Click-to-play inline promo players (BuildFree / Included) ---------- */
  /* preload="none" so these two cost zero bandwidth until a visitor actually taps play —
     only the hero video autoplays. Poster image + a play button standing in for the video
     until then. */
  .inline-video {
    max-width: 480px; margin: 40px auto 0; border-radius: 18px; overflow: hidden;
    border: 1px solid var(--border); box-shadow: 0 16px 44px rgba(0,0,0,0.35);
    position: relative; background: var(--bg-secondary); cursor: pointer;
  }
  .inline-video video { width: 100%; display: block; aspect-ratio: 16/9; object-fit: cover; background: #000; }
  .inline-video .iv-play {
    position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
    background: rgba(7,8,15,0.28); transition: background .2s ease;
  }
  .inline-video:hover .iv-play { background: rgba(7,8,15,0.42); }
  .inline-video .iv-play::after {
    content: "▶"; width: 62px; height: 62px; border-radius: 50%;
    background: rgba(255,255,255,0.94); color: var(--accent-deep);
    display: flex; align-items: center; justify-content: center; font-size: 1.3rem; padding-left: 4px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  }
  .inline-video .iv-len {
    position: absolute; bottom: 10px; right: 10px; background: rgba(7,8,15,0.72); backdrop-filter: blur(6px);
    color: #fff; font-size: .72rem; font-weight: 700; padding: 4px 9px; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
  }
  .inline-video.iv-playing .iv-play, .inline-video.iv-playing .iv-len { display: none; }
  .iv-cap { color: var(--text-secondary); font-size: .88rem; max-width: 480px; margin: 12px auto 0; text-align: center; }
  .hero-trustrow {
    display: flex; flex-wrap: wrap; justify-content: center; gap: 10px 18px;
    margin: 4px auto 34px; color: var(--text-secondary); font-size: .88rem; max-width: 720px;
  }
  .hero-trustrow span { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }

  .statbar {
    display: flex; flex-wrap: wrap; justify-content: center; gap: 14px;
    margin: 46px auto 0; max-width: 900px;
  }
  .stat {
    flex: 1 1 200px; background: linear-gradient(180deg,var(--bg-card),var(--bg-secondary));
    border: 1px solid var(--border); border-radius: var(--radius); padding: 22px 20px;
  }
  .stat .num { font-size: 2rem; font-weight: 800; }
  .stat .lbl { color: var(--text-secondary); font-size: .9rem; margin-top: 4px; }

  /* ---------- Section shells ---------- */
  .section-pad { padding: 84px 0; }
  .band { background: linear-gradient(180deg, transparent, rgba(13,17,23,0.6)); }
  .center { text-align: center; }
  .eyebrow { color: var(--accent-light); font-weight: 700; letter-spacing: .08em; text-transform: uppercase; font-size: .8rem; }
  .h2 { font-size: clamp(1.9rem, 4vw, 2.7rem); margin: 12px 0 14px; }
  .lead { color: var(--text-secondary); font-size: 1.1rem; max-width: 620px; margin: 0 auto; }

  /* ---------- Pain → cards ---------- */
  .grid3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; margin-top: 46px; }
  .card {
    background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius);
    padding: 28px 24px; transition: all .25s ease;
  }
  .card:hover { border-color: var(--border-accent); background: var(--bg-card-hover); transform: translateY(-3px); }
  .card .ic { font-size: 1.7rem; margin-bottom: 12px; }
  .card h3 { font-size: 1.18rem; margin-bottom: 8px; }
  .card p { color: var(--text-secondary); font-size: .96rem; }

  /* ---------- How it works ---------- */
  .steps { display: grid; grid-template-columns: repeat(3,1fr); gap: 22px; margin-top: 48px; counter-reset: step; }
  .step {
    position: relative; background: var(--bg-card); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 34px 26px 28px;
  }
  .step .n {
    position: absolute; top: -20px; left: 26px;
    width: 42px; height: 42px; border-radius: 12px;
    background: linear-gradient(135deg,var(--accent-light),var(--accent-deep));
    color: #fff; font-weight: 800; font-size: 1.2rem; display: grid; place-items: center;
    box-shadow: 0 8px 24px var(--accent-glow);
  }
  .step h3 { font-size: 1.2rem; margin: 14px 0 8px; }
  .step p { color: var(--text-secondary); font-size: .97rem; }
  .step .tag { color: var(--green-light); font-size: .84rem; font-weight: 700; margin-top: 12px; display: inline-block; }

  /* ---------- Before / After ---------- */
  .ba { display: grid; grid-template-columns: 1fr 1fr; gap: 22px; margin-top: 48px; align-items: stretch; }
  .ba-col { border-radius: var(--radius); overflow: hidden; border: 1px solid var(--border); }
  .ba-head { padding: 12px 18px; font-weight: 700; font-size: .9rem; display: flex; align-items: center; gap: 8px; }
  .ba-before .ba-head { background: rgba(148,163,184,0.08); color: var(--text-muted); }
  .ba-after  .ba-head { background: rgba(34,197,94,0.1); color: var(--green-light); }
  /* fake browser mock */
  .mock { background: var(--bg-secondary); }
  .mock-bar { display: flex; align-items: center; gap: 6px; padding: 9px 12px; background: #0a0c16; border-bottom: 1px solid var(--border); }
  .mock-bar i { width: 10px; height: 10px; border-radius: 50%; background: #303645; display: inline-block; }
  .mock-url { flex: 1; margin-left: 8px; height: 18px; border-radius: 6px; background: #12151f; }
  .mock-body { padding: 22px; min-height: 240px; }
  /* BEFORE look — dated */
  .old { font-family: 'Times New Roman', Times, serif; color: #b8b8b8; text-align: center; }
  .old h4 { color: #dcdcdc; font-size: 1.3rem; font-weight: 400; margin-bottom: 8px; text-decoration: underline; }
  .old p { font-size: .9rem; margin: 6px 0; }
  .old .btn-old { display: inline-block; margin-top: 14px; background: #b0b0b0; color: #222; padding: 6px 14px; border: 2px outset #ddd; font-size: .85rem; }
  .old .under { border: 1px dashed #555; padding: 10px; margin-top: 14px; font-size: .78rem; color: #888; }
  /* AFTER look — modern mini */
  .new .np { height: 92px; border-radius: 10px; background: linear-gradient(135deg,#1a1040,#312e81); position: relative; overflow: hidden; }
  .new .np::after { content:""; position: absolute; width: 120px; height: 120px; border-radius: 50%; background: rgba(99,102,241,0.4); filter: blur(30px); top: -20px; right: -10px; }
  .new .np b { position: absolute; left: 16px; bottom: 14px; color: #fff; font-size: 1.05rem; z-index: 1; }
  .new .row { display: flex; gap: 8px; margin-top: 12px; }
  .new .row div { flex: 1; height: 46px; border-radius: 8px; background: var(--bg-card); border: 1px solid var(--border); }
  .new .nbtn { margin-top: 14px; display: inline-block; background: linear-gradient(135deg,#22c55e,#16a34a); color:#04140a; font-weight: 700; font-size: .85rem; padding: 8px 16px; border-radius: 9px; }
  .new .line { height: 9px; border-radius: 5px; background: #232636; margin-top: 12px; }
  .new .line.s { width: 60%; }

  /* ---------- Examples ---------- */
  .exgrid { display: grid; grid-template-columns: repeat(3,1fr); gap: 18px; margin-top: 44px; }
  .ex {
    border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden;
    background: var(--bg-card); transition: all .25s ease;
  }
  .ex:hover { transform: translateY(-4px); border-color: var(--accent); box-shadow: 0 16px 40px rgba(0,0,0,0.4); }
  .ex .thumb { height: 128px; position: relative; overflow: hidden; }
  .ex .thumb::after { content:""; position: absolute; inset: 0; background: linear-gradient(180deg,transparent 55%, rgba(7,8,15,0.55)); }
  .ex .meta { padding: 14px 16px; }
  .ex .meta .ind { font-weight: 700; font-size: 1rem; }
  .ex .meta .biz { color: var(--text-muted); font-size: .85rem; margin-top: 2px; }
  /* varied gradient thumbs */
  .g1 { background: linear-gradient(135deg,#f0abfc,#6366f1); }
  .g2 { background: linear-gradient(135deg,#4ade80,#166534); }
  .g3 { background: linear-gradient(135deg,#f59e0b,#7c2d12); }
  .g4 { background: linear-gradient(135deg,#818cf8,#0d1117); }
  .g5 { background: linear-gradient(135deg,#fb7185,#7c2d12); }
  .g6 { background: linear-gradient(135deg,#f9a8d4,#831843); }
  .ex .tt { position: absolute; z-index: 2; left: 14px; bottom: 12px; color: #fff; font-weight: 700; font-size: 1.05rem; text-shadow: 0 2px 8px rgba(0,0,0,0.5); }

  /* ---------- Pricing ---------- */
  .price-card {
    max-width: 940px; margin: 46px auto 0; background: linear-gradient(180deg,var(--bg-card),var(--bg-secondary));
    border: 1px solid var(--border-accent); border-radius: 24px; padding: 40px; position: relative; overflow: hidden;
  }
  .price-card::before { content:""; position: absolute; width: 300px; height: 300px; border-radius: 50%; background: var(--accent-glow); filter: blur(70px); top: -100px; right: -60px; }
  .price-flag {
    position: absolute; top: 0; right: 0; background: linear-gradient(135deg,#22c55e,#16a34a);
    color: #04140a; font-weight: 800; font-size: .82rem; padding: 8px 20px; border-bottom-left-radius: 16px; letter-spacing: .02em;
  }
  .price-inner { position: relative; z-index: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 36px; align-items: center; }
  .price-num { display: flex; align-items: baseline; gap: 10px; }
  .price-num .big { font-size: 4rem; font-weight: 800; }
  .price-num .once { color: var(--text-secondary); font-weight: 600; }
  .anchor { margin: 6px 0 18px; }
  .anchor .old { font-family: var(--font); color: var(--text-muted); text-decoration: line-through; font-size: 1.2rem; text-align: left; }
  .anchor .note { color: var(--green-light); font-weight: 700; font-size: .9rem; margin-left: 8px; }
  .incl { list-style: none; display: grid; gap: 11px 26px; }
  @media (min-width: 640px) { .incl { grid-template-columns: repeat(2,1fr); } }
  .incl li { display: flex; gap: 11px; color: var(--text-secondary); font-size: .97rem; align-items: flex-start; }
  .incl .ck { flex: none; width: 22px; height: 22px; border-radius: 50%; background: rgba(34,197,94,0.16); color: var(--green-light); display: grid; place-items: center; font-size: .8rem; font-weight: 800; margin-top: 1px; }
  .price-foot { position: relative; z-index: 1; margin-top: 26px; padding-top: 22px; border-top: 1px solid var(--border); color: var(--text-muted); font-size: .88rem; text-align: center; }
  .compare { margin-top: 8px; font-size: .82rem; color: var(--text-muted); }
  .compare b { color: var(--text-secondary); }
  .addon-note { margin-top: 14px; font-size: .88rem; color: var(--text-secondary); }
  .addon-note a { color: var(--accent-light); font-weight: 700; }
  .pilot-line { margin-top: 10px; font-size: .86rem; color: var(--text-muted); }
  .pilot-line b { color: var(--text-secondary); }

  /* ---------- Add-ons row (optional, never part of the $199) ---------- */
  .grid2 { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; margin-top: 20px; }
  .card-dashed { border-style: dashed; }
  .price-tag { color: var(--green-light); font-weight: 800; }

  /* ---------- Try-it-now demo widgets ---------- */
  .try-it-block { margin-top: 46px; text-align: left; }
  .try-it-block .try-head { text-align: center; margin-bottom: 8px; }
  .demo-card { display: flex; flex-direction: column; gap: 10px; text-align: left; }
  .demo-card h4 { font-size: 1.05rem; margin: 2px 0 0; }
  .demo-sub { color: var(--text-secondary); font-size: .86rem; margin: 0; }
  .demo-input, .demo-textarea {
    width: 100%; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 10px;
    color: var(--text-primary); font-family: var(--font); font-size: .92rem; padding: 10px 12px;
  }
  .demo-textarea { resize: vertical; min-height: 84px; }
  .demo-input:focus, .demo-textarea:focus { outline: none; border-color: var(--accent); }
  .demo-input::placeholder, .demo-textarea::placeholder { color: var(--text-muted); }
  .demo-btn {
    display: inline-flex; align-items: center; justify-content: center; gap: 8px;
    background: linear-gradient(135deg,#6366f1,#4f46e5); color: #fff; font-weight: 700; font-size: .92rem;
    border: none; border-radius: 11px; padding: 11px 18px; cursor: pointer; transition: all .2s ease;
  }
  .demo-btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 20px var(--accent-glow); }
  .demo-btn:disabled { opacity: .55; cursor: not-allowed; }
  .demo-error { color: #fca5a5; font-size: .85rem; margin: 0; }
  .demo-result {
    margin-top: 2px; background: var(--bg-secondary); border: 1px solid var(--border-accent); border-radius: 12px;
    padding: 14px 16px; font-size: .92rem; color: var(--text-primary);
  }
  .demo-result h5 { font-size: .76rem; text-transform: uppercase; letter-spacing: .05em; color: var(--accent-light); margin-bottom: 6px; }
  .demo-result p { color: var(--text-primary); }
  .demo-result ul { margin: 8px 0 0 18px; padding: 0; color: var(--text-secondary); }
  .demo-result li { margin-bottom: 4px; }
  .demo-cta { display: inline-block; margin-top: 2px; color: var(--green-light); font-weight: 700; font-size: .88rem; }
  .demo-privacy { color: var(--text-muted); font-size: .76rem; margin: 2px 0 0; }

  /* ---------- Social proof ---------- */
  .quotes { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; margin-top: 44px; }
  .quote { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius); padding: 26px 24px; }
  .stars { color: #fbbf24; letter-spacing: 2px; margin-bottom: 12px; font-size: .95rem; }
  .quote p { color: var(--text-primary); font-size: .98rem; margin-bottom: 16px; }
  .who { display: flex; align-items: center; gap: 11px; }
  .who .av { width: 38px; height: 38px; border-radius: 50%; background: linear-gradient(135deg,var(--accent-light),var(--accent-deep)); color: #fff; display: grid; place-items: center; font-weight: 700; }
  .who .nm { font-weight: 700; font-size: .9rem; }
  .who .rl { color: var(--text-muted); font-size: .8rem; }
  .trustrow { display: flex; flex-wrap: wrap; justify-content: center; gap: 26px; margin-top: 40px; color: var(--text-secondary); font-size: .92rem; }
  .trustrow span { display: inline-flex; align-items: center; gap: 8px; }

  /* ---------- FAQ ---------- */
  .faq { max-width: 780px; margin: 44px auto 0; }
  details {
    background: var(--bg-card); border: 1px solid var(--border); border-radius: 14px;
    padding: 4px 22px; margin-bottom: 12px; transition: border-color .2s;
  }
  details[open] { border-color: var(--border-accent); }
  summary { cursor: pointer; font-weight: 700; font-size: 1.04rem; padding: 16px 0; list-style: none; display: flex; justify-content: space-between; align-items: center; gap: 16px; }
  summary::-webkit-details-marker { display: none; }
  summary::after { content: "+"; color: var(--accent-light); font-size: 1.5rem; font-weight: 400; transition: transform .2s; }
  details[open] summary::after { transform: rotate(45deg); }
  details p { color: var(--text-secondary); padding: 0 0 18px; font-size: .97rem; }

  /* ---------- Final CTA ---------- */
  .finalcta { text-align: center; padding: 90px 0; position: relative; overflow: hidden; }
  .finalcta::before { content:""; position: absolute; inset: 0; background: radial-gradient(600px 300px at 50% 0%, rgba(99,102,241,0.2), transparent 70%); }
  .finalcta .wrap { position: relative; z-index: 1; }
  .finalcta h2 { font-size: clamp(2rem,4.5vw,3rem); margin-bottom: 16px; }
  .finalcta p { color: var(--text-secondary); font-size: 1.12rem; max-width: 560px; margin: 0 auto 30px; }

  /* ---------- Footer ---------- */
  footer { border-top: 1px solid var(--border); padding: 40px 0; color: var(--text-muted); font-size: .9rem; }
  .foot { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 18px; align-items: center; }
  .foot a { color: var(--text-secondary); }
  .foot a:hover { color: var(--text-primary); }
  .built { color: var(--text-muted); font-size: .82rem; margin-top: 10px; }

  /* ---------- Responsive ---------- */
  @media (max-width: 860px) {
    .grid3, .grid2, .steps, .exgrid, .quotes, .ba, .price-inner { grid-template-columns: 1fr; }
    .nav-links a:not(.nav-phone) { display: none; }
    .exgrid { grid-template-columns: 1fr 1fr; }
    .step .n { top: -18px; }
    .price-card { padding: 28px; }
    .price-num .big { font-size: 3.2rem; }
  }
  @media (max-width: 520px) {
    .exgrid { grid-template-columns: 1fr; }
    .hero { padding: 40px 0 30px; }
    .hero h1 { margin: 14px 0 12px; }
    .hero .sub:nth-of-type(2) { display: none; }  /* trim hero height on phones so the CTA stays above the fold */
    .hero .price-line { margin-bottom: 16px; }
    /* 2026-09-18 conversion audit: the hero CTA's long label ("See a free sample of
       YOUR site first — pay $0 until you approve it") was set with white-space:nowrap
       (base .btn rule) inside a width:100% button. At phone widths the text was ~105px
       wider than the button, so it overflowed silently off both edges — and since the
       overflow rendered in the button's near-black text color against the page's dark
       background, the overflowing words were invisible. Confirmed via headless-Chrome
       DOM measurement (scrollWidth 447 vs clientWidth 342 at 390px) and visually in the
       screenshot (only the middle of the sentence was legible). Letting it wrap fixes it. */
    .btn { width: 100%; justify-content: center; white-space: normal; text-align: center; line-height: 1.3; }
    .cta-row { flex-direction: column; margin-bottom: 10px; }
  }

  /* ---------- Light-mode friendliness ---------- */
  @media (prefers-color-scheme: light) and (min-width: 99999px) {
    :root {
      --bg-primary:   #f6f7fb;
      --bg-secondary: #ffffff;
      --bg-card:      #ffffff;
      --bg-card-hover:#f1f3fa;
      --border:       #e2e8f0;
      --border-accent:#c7d2fe;
      --text-primary: #0f172a;
      --text-secondary:#475569;
      --text-muted:   #94a3b8;
      --accent-glow:  rgba(99,102,241,0.1);
    }
    body { background: var(--bg-primary); }
    header { background: rgba(255,255,255,0.8); }
    .topbar { color: #fff; }
    .grad-text { background: linear-gradient(135deg,#312e81 0%, #6366f1 55%, #4f46e5 100%); -webkit-background-clip: text; background-clip: text; }
    .mock, .mock-body { background: #f8fafc; }
    .mock-bar { background: #eef2f7; }
    .mock-url { background: #e2e8f0; }
    .btn-primary { color: #fff; }
    .hero .price-line b { color: var(--text-primary); }   /* fix: was invisible white on light bg */
    .hero::before { background: rgba(99,102,241,0.16); }   /* keep the accent glow visible in light */
    .hero::after  { background: rgba(34,197,94,0.09); }
    .stat, .step, .card, .ex, .quote, details, .price-card { box-shadow: 0 4px 20px rgba(15,23,42,0.06); }
    .price-card { box-shadow: 0 20px 50px rgba(99,102,241,0.12); }
    .btn-primary { box-shadow: 0 8px 24px rgba(34,197,94,0.28); }
  }
`;

export const GN_HTML = `

<header>
  <div class="topbar">🚀 Founding rate — $199 this month, then $299. Lock it in while it lasts.</div>
  <div class="wrap">
    <nav>
      <div class="logo"><span class="mark">G</span> GlobalNow</div>
      <div class="nav-links">
        <a href="#how">How it works</a>
        <a href="#ai">AI included</a>
        <a href="#examples">Examples</a>
        <a href="/order">Pricing</a>
        <a href="#faq">FAQ</a>
        <a class="nav-phone" href="tel:+14077068990">📞 (407) 706-8990 <span>· 24/7</span></a>
        <a href="/order" class="btn btn-primary btn-sm">Build my site → $199</a>
      </div>
    </nav>
  </div>
</header>

<!-- ===================== HERO ===================== -->
<section class="hero">
  <div class="wrap">
    <span class="pill pill-green"><span class="dot"></span> Done for you · Live this week · No monthly fees</span>
    <h1><span class="grad-text">Customers Google you.<br>Right now they find nothing.</span></h1>
    <p class="sub">27% of local businesses still have no real website in 2026 — so people search, come up empty, and call the next name on the list. We put you online with a modern, mobile-ready site you're proud to share.</p>
    <p class="sub">It even installs on your customers' phones like an app — your logo on their home screen, one tap to call you. Included.</p>
    <p class="price-line"><b>$199 one-time.</b> Done for you. Live this week. <span class="green-text">No monthly fees, ever.</span></p>
    <div class="cta-row">
      <a href="/order" class="btn btn-primary">🚀 See a free sample of YOUR site first — pay $0 until you approve it</a>
      <a href="#examples" class="btn btn-ghost">See real examples →</a>
    </div>
    <p class="microtrust">Reply with your business name and we build the sample before you decide. Questions first? Call a real person — <a href="tel:+14077068990">(407) 706-8990</a>, answered 24/7.</p>

    <div class="hero-video-wrap">
      <span class="hero-video-badge">▶ Real 48-hour build, real site</span>
      <video autoplay muted loop playsinline preload="metadata" width="640" height="360" poster="/videos/globalnow-hero-poster.webp">
        <source src="/videos/GlobalNow-Promo-48hrs-16x9.mp4" type="video/mp4">
      </video>
    </div>
    <div class="hero-trustrow">
      <span>✅ Sample first</span>
      <span>💵 $0 until you approve</span>
      <span>⚡ 48 h</span>
      <span>🚫 No monthly fees</span>
      <span>📲 Installs like an app</span>
    </div>

    <div class="statbar">
      <div class="stat"><div class="num grad-text">27%</div><div class="lbl">of U.S. small businesses have no website — invisible when customers search.</div></div>
      <div class="stat"><div class="num green-text">+39%</div><div class="lbl">more revenue, on average, for businesses that get a real website.</div></div>
      <div class="stat"><div class="num grad-text">This week</div><div class="lbl">from "I have nothing" to live on your own domain — as fast as 48 hours.</div></div>
    </div>
  </div>
</section>

<!-- ===================== HEAR THE AI WORK, LIVE ===================== -->
<section class="section-pad band" id="hear-it-work">
  <div class="wrap center">
    <span class="eyebrow">Not a mockup — a real call</span>
    <h2 class="h2">Call it. Hear the AI answer and book the job.</h2>
    <p class="lead">Every GlobalNow site can include an AI phone answerer. Call this number right now — tell it "my AC is broken," give any address, pick a time — and watch it book you and text a confirmation.</p>
    <a class="phone" href="tel:+18886310418" style="display:inline-block;margin:18px 0;padding:18px 32px;font-size:clamp(1.3rem,4vw,1.8rem);font-weight:800;color:#04140a;background:linear-gradient(135deg,#22c55e,#16a34a);border-radius:14px;text-decoration:none;box-shadow:0 8px 30px rgba(34,197,94,.35)">📞 (888) 631-0418</a>
    <p class="microtrust">On desktop? <a href="/call-demo.html" target="_blank" rel="noopener">See the full demo page →</a></p>
  </div>
</section>

<!-- ===================== SEE IT ON A PHONE ===================== -->
<section class="section-pad" id="phone-proof">
  <div class="wrap center">
    <span class="eyebrow">Not a mockup — a real site</span>
    <h2 class="h2">See it on a phone</h2>
    <p class="lead">Three real GlobalNow sites, screenshotted straight off a phone. Tap any one to open the live site.</p>
    <div class="exgrid">
      <a class="ex" href="/s/koskey-s-virtuous-cleaning/" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block;padding:18px 18px 14px;">
        <img src="/samples-shots/cleaning-koskeys.webp" width="390" height="844" loading="lazy" decoding="async" alt="Real GlobalNow site on a phone — cleaning business" style="border-radius:14px;border:1px solid var(--border);width:100%;height:auto;display:block;margin-bottom:12px;">
        <div class="meta" style="padding:0;"><div class="ind">Cleaning</div><div class="biz">Koskey's Virtuous Cleaning &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div>
      </a>
      <a class="ex" href="/s/m-m-contractor-and-renovations-llc/" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block;padding:18px 18px 14px;">
        <img src="/samples-shots/handyman-mmcontractor.webp" width="390" height="844" loading="lazy" decoding="async" alt="Real GlobalNow site on a phone — handyman/contractor business" style="border-radius:14px;border:1px solid var(--border);width:100%;height:auto;display:block;margin-bottom:12px;">
        <div class="meta" style="padding:0;"><div class="ind">Handyman &amp; Contracting</div><div class="biz">M &amp; M Contractor and Renovations &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div>
      </a>
      <a class="ex" href="/s/timothy-parks-roofing-construction-inc/" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block;padding:18px 18px 14px;">
        <img src="/samples-shots/roofing-timothyparks.webp" width="390" height="844" loading="lazy" decoding="async" alt="Real GlobalNow site on a phone — roofing business" style="border-radius:14px;border:1px solid var(--border);width:100%;height:auto;display:block;margin-bottom:12px;">
        <div class="meta" style="padding:0;"><div class="ind">Roofing &amp; Construction</div><div class="biz">Timothy Parks Roofing &amp; Construction &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div>
      </a>
    </div>
    <p class="microtrust" style="margin-top:22px;">See more across other trades in the <a href="/samples/">full sample gallery →</a></p>
  </div>
</section>

<!-- ===================== PROBLEM ===================== -->
<section class="section-pad band">
  <div class="wrap center">
    <span class="eyebrow">The real cost of no website</span>
    <h2 class="h2">A Facebook page isn't a website</h2>
    <p class="lead">If your whole online presence is a social page — or a site that looks like it's from 2012 — here's what it's quietly costing you every week.</p>
    <div class="grid3">
      <div class="card">
        <div class="ic">🔎</div>
        <h3>You're invisible on Google</h3>
        <p>People search your trade + your town. No site means no results — so the job goes to whoever shows up first. That's a competitor, every single day.</p>
      </div>
      <div class="card">
        <div class="ic">📱</div>
        <h3>The old site scares people off</h3>
        <p>Tiny text, broken on phones, no way to contact you. 8 in 10 customers judge your business by your site — a dated one says "closed or careless."</p>
      </div>
      <div class="card">
        <div class="ic">🧩</div>
        <h3>DIY builders eat your weekends</h3>
        <p>Wix and Squarespace hand you a blank canvas and a monthly bill. You didn't start a business to become a part-time web designer.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===================== HOW IT WORKS ===================== -->
<section class="section-pad" id="how">
  <div class="wrap center">
    <span class="eyebrow">Done for you — you barely lift a finger</span>
    <h2 class="h2">Live in three simple steps</h2>
    <p class="lead">No logins to learn, no templates to fight, no homework. You answer a few questions — our AI team and a real human do the rest.</p>
    <div class="steps">
      <div class="step">
        <div class="n">1</div>
        <h3>Answer 5 quick questions</h3>
        <p>Your business name, what you do, and how customers reach you. Two minutes, from your phone. No accounts, no tech skills needed.</p>
        <span class="tag">⏱ Takes ~2 minutes</span>
      </div>
      <div class="step">
        <div class="n">2</div>
        <h3>We build it — and check it</h3>
        <p>Our AI team writes your copy, designs the pages, and adds your photos and contact form. AI builds the draft in minutes. A real person polishes and checks every page before it goes live.</p>
        <span class="tag">🤖 AI builds · 👤 human approves</span>
      </div>
      <div class="step">
        <div class="n">3</div>
        <h3>Preview, tweak, go live</h3>
        <p>You get a private preview and one full revision round — we fix anything you don't love. Then you're live on your own domain, usually within 48 hours.</p>
        <span class="tag">🚀 Live this week</span>
      </div>
    </div>

    <div class="inline-video" data-src="/videos/GlobalNow-Promo-BuildFree-16x9.mp4" role="button" tabindex="0" aria-label="Play video: We build it free, you only pay if you love it (33 seconds)" onclick="window.gnPlayInline(this)" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();window.gnPlayInline(this);}">
      <video preload="none" playsinline poster="/img/globalnow-buildfree-poster.webp" aria-hidden="true"></video>
      <span class="iv-play" aria-hidden="true"></span>
      <span class="iv-len">0:33</span>
    </div>
    <p class="iv-cap">Watch how it works: answer 5 questions, we build your free sample, you pay $0 until you approve it.</p>
  </div>
</section>

<!-- ===================== AI INCLUDED ===================== -->
<section class="section-pad" id="ai">
  <div class="wrap center">
    <span class="eyebrow">Not just a website — an AI-powered one</span>
    <h2 class="h2">Your $199 site comes with AI working for you</h2>
    <p class="lead">Wix gives you a blank canvas. We give you a site that actually does things for you.</p>
    <div class="grid3">
      <div class="card">
        <div class="ic">💬</div>
        <h3>AI answers your customers 24/7</h3>
        <p>A smart answer bubble on your site, trained on YOUR business — hours, services, service area, what to expect. Customers get instant answers at 11pm while your competitors' phones ring out.</p>
      </div>
      <div class="card">
        <div class="ic">✍️</div>
        <h3>AI writes your site from your real reviews</h3>
        <p>Our AI reads your actual customer reviews and writes your pages from them — so your site sounds like you, backed by what real customers already say. No generic template filler.</p>
      </div>
      <div class="card">
        <div class="ic">📍</div>
        <h3>Google Business Profile tune-up</h3>
        <p>We optimize your Google Business Profile description and hand you a starter pack of posts — so the map listing customers actually tap on matches your new site.</p>
      </div>
    </div>
    <p class="microtrust" style="margin-top:26px;">All three included in the $199 — because our AI does the work, not a billable-hours team.</p>

    <div class="try-it-block">
      <div class="try-head">
        <span class="eyebrow">Don't take our word for it</span>
        <h3 style="font-size:1.5rem;margin:10px 0 8px;">Test the 24/7 answer bubble — pick your trade and ask a real customer question</h3>
        <p class="lead">Three real demos of the AI your $199 site would use. Type something real, see what it does. Nothing you enter is saved.</p>
      </div>
      <div class="grid3" style="align-items:start;">
        <div id="widget-mount-answer"></div>
        <div id="widget-mount-reviews"></div>
        <div id="widget-mount-gbp"></div>
      </div>
    </div>

    <div class="grid2" id="addons">
      <div class="card card-dashed">
        <div class="ic">🔄</div>
        <h3>Monthly AI Refresh <span class="price-tag">$19/mo</span></h3>
        <p>Optional. Once a month, our AI reviews your latest customer reviews and quietly updates your homepage highlights and one Google Business post — so your site never goes stale. Cancel anytime, no contract.</p>
      </div>
      <div class="card card-dashed">
        <div class="ic">📞</div>
        <h3>Missed-Call Text-Back <span class="price-tag">$39/mo</span></h3>
        <p>Optional. The moment a call to your business goes unanswered, the caller gets an instant text back with a link to book — day or night. Add it to any GlobalNow site.</p>
      </div>
    </div>
    <p class="addon-note">Both are <b>optional add-ons</b> — your $199 site works completely on its own, with <span class="green-text">no monthly fees, ever</span>. <a href="/order">Add one at checkout →</a></p>
  </div>
</section>

<!-- ===================== BEFORE / AFTER ===================== -->
<section class="section-pad band">
  <div class="wrap center">
    <span class="eyebrow">Before &amp; after</span>
    <h2 class="h2">From "call the next guy" to "wow, book them"</h2>
    <p class="lead">Same business. Same phone number. The difference a modern site makes to the customer deciding whether to trust you.</p>
    <div class="ba">
      <div class="ba-col ba-before">
        <div class="ba-head">✕ BEFORE — no site or a dated one</div>
        <div class="mock">
          <div class="mock-bar"><i></i><i></i><i></i><div class="mock-url"></div></div>
          <div class="mock-body old">
            <h4>Welcome To Our Homepage!!</h4>
            <p>~ Under Construction ~</p>
            <p>Call for pricing &amp; hours</p>
            <p>Best viewed at 800x600</p>
            <div class="under">This site works better on a computer</div>
            <span class="btn-old">Click Here to Email Us</span>
          </div>
        </div>
      </div>
      <div class="ba-col ba-after">
        <div class="ba-head">✓ AFTER — your GlobalNow site</div>
        <div class="mock">
          <div class="mock-bar"><i></i><i></i><i></i><div class="mock-url"></div></div>
          <div class="mock-body new">
            <div class="np"><b>Trusted local pros, ready today</b></div>
            <div class="row"><div></div><div></div><div></div></div>
            <div class="line"></div>
            <div class="line s"></div>
            <span class="nbtn">Get a Free Quote →</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===================== EXAMPLES ===================== -->
<section class="section-pad" id="examples">
  <div class="wrap center">
    <span class="eyebrow">Designs across industries</span>
    <h2 class="h2">What your site could look like</h2>
    <p class="lead">Example designs across common local industries — clean, modern, and mobile-ready. Your site is custom-built for your business, your services, and your photos.</p>
    <div class="exgrid">
      <a class="ex" href="https://gn-demo-medspa.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/medspa.jpg) center top/cover"><span class="tt">Luminara Med Spa</span></div><div class="meta"><div class="ind">Med Spa</div><div class="biz">Booking, services &amp; gallery &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
      <a class="ex" href="https://gn-demo-landscaper.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/landscaper.jpg) center top/cover"><span class="tt">Stonebrook Landscaping</span></div><div class="meta"><div class="ind">Landscaping</div><div class="biz">Quote form &amp; project photos &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
      <a class="ex" href="https://gn-demo-gym.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/gym.jpg) center top/cover"><span class="tt">Ironhawk Fitness</span></div><div class="meta"><div class="ind">Gym &amp; Fitness</div><div class="biz">Class schedule &amp; sign-up &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
      <a class="ex" href="https://gn-demo-photographer.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/photographer.jpg) center top/cover"><span class="tt">Aperture Lane</span></div><div class="meta"><div class="ind">Photography</div><div class="biz">Portfolio &amp; contact &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
      <a class="ex" href="https://gn-demo-restaurant.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/restaurant.jpg) center top/cover"><span class="tt">Saffron &amp; Sage</span></div><div class="meta"><div class="ind">Restaurant</div><div class="biz">Menu, hours &amp; directions &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
      <a class="ex" href="https://gn-demo-wedding.netlify.app" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;display:block"><div class="thumb" style="background:url(/ex/wedding.jpg) center top/cover"><span class="tt">Everly Rose Events</span></div><div class="meta"><div class="ind">Wedding Vendor</div><div class="biz">Packages &amp; inquiry form &middot; <span style="color:#4f8cff;font-weight:600">View live &#8599;</span></div></div></a>
    </div>
  </div>
</section>

<!-- ===================== PRICING ===================== -->
<section class="section-pad band" id="pricing">
  <div class="wrap center">
    <span class="eyebrow">One price. Done for you. Yours forever.</span>
    <h2 class="h2">$199 once — not $199 a month</h2>
    <p class="lead">No subscriptions. No hosting bill. No DIY homework. Pay once, own it, keep it.</p>

    <div class="price-card">
      <div class="price-flag">⚡ FOUNDING RATE</div>
      <div class="price-inner">
        <div>
          <h3 style="font-size:1.5rem;margin-bottom:10px;">Done-For-You Website</h3>
          <div class="price-num"><span class="big grad-text">$199</span><span class="once">one-time</span></div>
          <div class="anchor"><span class="old">$299</span><span class="note">after the founding period</span></div>
          <p style="color:var(--text-secondary);margin-bottom:22px;">Live within 48 hours of your order. One full revision round included. Cancel-proof — there's nothing to cancel.</p>
          <a href="/order" class="btn btn-primary" style="margin-bottom:12px;">🚀 Build my site → $199</a>
          <p class="microtrust">Prefer to talk first? <a href="tel:+14077068990">(407) 706-8990</a></p>
        </div>
        <div>
          <ul class="incl">
            <li><span class="ck">✓</span> A custom 4–5 page website (home, services, about, contact) built to turn visitors into calls</li>
            <li><span class="ck">✓</span> Your page copy written for you from your real Google reviews — no writing needed</li>
            <li><span class="ck">✓</span> Big, one-tap call buttons everywhere so people reach you instantly</li>
            <li><span class="ck">✓</span> 💬 24/7 AI answer bubble — handles routine customer questions when you can't pick up</li>
            <li><span class="ck">✓</span> 📍 Google Business Profile tune-up — fresh description + starter posts</li>
            <li><span class="ck">✓</span> 📲 Installs on customers' phones like an app — one tap to call, your logo on their home screen</li>
            <li><span class="ck">✓</span> Working contact form, plus a link to your booking or payment tools if you have them</li>
            <li><span class="ck">✓</span> Professional photos, and an interactive map when you give us an address</li>
            <li><span class="ck">✓</span> Your own domain connected free — no hosting bill, no monthly fees, ever</li>
            <li><span class="ck">✓</span> One full revision round — we fix anything you don't love</li>
            <li><span class="ck">✓</span> Live within 48 hours</li>
            <li><span class="ck">✓</span> 30-day satisfaction guarantee</li>
          </ul>
          <p class="addon-note">Optional add-ons if you want them: Monthly AI Refresh ($19/mo) and Missed-Call Text-Back ($39/mo) — <a href="#addons">see details ↑</a>. Never required.</p>

          <div class="inline-video" style="margin-top:26px;max-width:100%" data-src="/videos/GlobalNow-Promo-Included-16x9.mp4" role="button" tabindex="0" aria-label="Play video: Everything included for $199 (65 seconds)" onclick="window.gnPlayInline(this)" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();window.gnPlayInline(this);}">
            <video preload="none" playsinline poster="/img/globalnow-included-poster.webp" aria-hidden="true"></video>
            <span class="iv-play" aria-hidden="true"></span>
            <span class="iv-len">1:05</span>
          </div>
          <p class="iv-cap" style="margin-left:0;margin-right:0">A minute-long walkthrough of every item on this list — reviews-based copy, AI answer bubble, app install, and more.</p>
        </div>
      </div>
      <div class="price-foot">
        💎 Founding rate — this month · 🔒 Secure checkout · ⚡ Live in 48 hours · 🛡️ 30-day satisfaction guarantee
        <div class="compare">Wix charges <b>$17–$159/mo</b>. Squarespace <b>$16+/mo</b>. A freelancer quotes <b>$500–$2,000</b>. You pay <b>$199 once</b> — and own it forever.</div>
        <div class="compare">Bells &amp; whistles — what agencies charge extra for, included free: a Google-review button, FAQ answers built for search engines, hours with an open-now badge, your service area listed, a "save our number" contact card, and a QR code for flyers or a truck decal.</div>
        <div class="pilot-line">Want more than a website — someone catching every lead? Ask about the <b>30-Day AI Office Pilot ($997, one-time)</b> once you're live.</div>
      </div>
    </div>
    <div class="card" style="max-width:640px;margin:22px auto 0;text-align:left;">
      <h3 style="font-size:1.1rem;margin-bottom:8px;">Wait — how is there no monthly fee?</h3>
      <p>We host your site on fast, secure cloud hosting that costs us almost nothing to run, so we include it. You own the site. If you ever want to move it, we hand you the files. The only thing that costs money is a custom domain name (about $15 a year, optional) — we connect it for free.</p>
    </div>
  </div>
</section>

<!-- ===================== SOCIAL PROOF ===================== -->
<section class="section-pad">
  <div class="wrap center">
    <span class="eyebrow">Why owners trust us</span>
    <h2 class="h2">Small shop, real humans, honest work</h2>
    <p class="lead">We're a small independent team — no call center, no upsell funnels. The AI does the heavy lifting; a real person signs off before anything goes live under your name.</p>
    <div class="trustrow" style="margin-top:44px;">
      <span>🛡️ 30-day satisfaction guarantee</span>
      <span>🔒 Secure checkout</span>
      <span>👤 Human-reviewed before launch</span>
      <span>📞 Real person on the phone, 24/7</span>
      <span>🚫 No monthly fees, ever</span>
    </div>
    <p class="built" style="margin-top:24px;">Just getting started — lock in the founding $199 rate this month. Every site is built by our AI team and signed off by a real person before it goes live under your name.</p>
  </div>
</section>

<!-- ===================== FAQ ===================== -->
<section class="section-pad band" id="faq">
  <div class="wrap">
    <div class="center"><span class="eyebrow">Straight answers</span><h2 class="h2">Questions owners actually ask</h2></div>
    <div class="faq">
      <details open><summary>Is it really $199 with no monthly fee?</summary><p>Yes. $199 one-time builds your whole site — copy, design, images, contact form, and hosting setup. There's no subscription and no hosting bill. Compare that to Wix ($17–$159/mo) or a freelancer ($500–$2,000). If you ever want ongoing changes we can help, but nothing is required — you own the site.</p></details>
      <details><summary>What's this AI stuff my site comes with?</summary><p>Three things, all included in the $199 — no extra charge: an AI answer bubble on your site that responds to customer questions (your hours, services, service area) around the clock; your page copy written by AI from your real customer reviews so it sounds authentic; and an AI-optimized Google Business Profile description with a starter pack of posts. Try all three live on this page before you buy. It's the same AI platform we use to run our own businesses. If you ever want more — a monthly refresh or missed-call text-back — those exist as small optional add-ons, but nothing beyond the $199 is ever required.</p></details>
      <details><summary>I'm not techy at all. What do I actually have to do?</summary><p>Answer 5 quick questions about your business — from your phone, in about two minutes. That's it. No accounts to set up, no templates to wrestle with, no design decisions. We handle everything and send you a preview to approve.</p></details>
      <details><summary>How fast is "live this week"?</summary><p>Most sites are live within 48 hours of your order and your answers. That includes the AI build, a human quality check, your private preview, and one revision round. Need it faster for a specific date? Call us and we'll work with you.</p></details>
      <details><summary>I already have an old website. Can you replace it?</summary><p>Absolutely — that's one of the most common jobs we do. We build the modern version and connect it to your existing domain so customers land on the new site at the same web address. Nothing breaks, and you keep your Google presence.</p></details>
      <details><summary>What if I don't love it?</summary><p>You get one full revision round — tell us what to change and we fix it. And every order is backed by a 30-day satisfaction guarantee. We're a small shop that lives on word of mouth, so getting it right matters to us.</p></details>
      <details><summary>Do I own it, or am I renting it from you?</summary><p>You own it. Your domain stays yours, and the site is yours to keep. There's no lock-in and nothing to cancel.</p></details>
    </div>
  </div>
</section>

<!-- ===================== FROM THE BLOG ===================== -->
<section class="section-pad band" id="blog-row">
  <div class="wrap center">
    <span class="eyebrow">Free advice, no strings</span>
    <h2 class="h2">From the blog</h2>
    <p class="lead">Plain-English help for local service businesses getting found online.</p>
    <div id="widget-mount-blog"></div>
  </div>
</section>

<!-- ===================== ORDER / START ===================== -->
<section class="section-pad band" id="start">
  <div class="wrap center">
    <span class="eyebrow">Start your site</span>
    <h2 class="h2">Get started — $199, live this week</h2>
    <p class="lead">Tell us a little about your business and we'll get your site moving today. Prefer to talk? Call <a href="tel:+14077068990" style="color:var(--accent-light);font-weight:700;">(407) 706-8990</a> — a real person, answered 24/7.</p>
    <a href="/order" class="btn btn-primary" style="justify-content:center;margin:34px auto 0;">🚀 Build my site → $199</a><p class="microtrust" style="text-align:center;margin-top:14px;">Answer a few quick questions — see your free sample, then decide · 30-day satisfaction guarantee · or call <a href="tel:+14077068990">(407) 706-8990</a></p>
  </div>
</section>

<!-- ===================== FINAL CTA ===================== -->
<section class="finalcta">
  <div class="wrap">
    <span class="pill pill-indigo">Founding rate — $199 this month, then $299</span>
    <h2 class="grad-text" style="margin-top:20px;">Stop losing customers to a Google search.</h2>
    <p>Answer five questions today, and be live on your own site this week. Done for you. $199 once. No monthly fees, ever.</p>
    <div class="cta-row">
      <a href="/order" class="btn btn-primary">🚀 Build my site → $199</a>
      <a href="tel:+14077068990" class="btn btn-ghost">📞 Talk to a human first</a>
    </div>
  </div>
</section>

<footer>
  <div class="wrap foot">
    <div>
      <div class="logo" style="font-size:1.05rem;"><span class="mark" style="width:26px;height:26px;font-size:.9rem;">G</span> GlobalNow</div>
      <div class="built">© 2026 GlobalNow · Modern websites for local business · Done for you, live this week.</div>
      <div class="built">Need the phone answered too, not just a website? See <a href="https://aisuperhub.dev/for/" style="color:var(--text-secondary)">AI SuperHub's AI Front Desk →</a></div>
    </div>
    <div style="display:flex;gap:20px;flex-wrap:wrap;align-items:center;">
      <a href="#how">How it works</a>
      <a href="#examples">Examples</a>
      <a href="/order">Pricing</a>
      <a href="#faq">FAQ</a>
      <a href="/faq/">Full FAQ + Video</a>
      <a href="tel:+14077068990">📞 (407) 706-8990</a>
    </div>
  </div>
</footer>

<script type="application/ld+json">{"@context":"https://schema.org","@type":"VideoObject","name":"Your Website, Live on Phones in 48 Hours","description":"A real GlobalNow site shown on a phone — tap-to-call, installs like an app, and live within 48 hours for $199 one-time, no monthly fees.","thumbnailUrl":["https://globalnow.biz/videos/globalnow-hero-poster.webp"],"uploadDate":"2026-09-17T12:00:00-04:00","duration":"PT21S","contentUrl":"https://globalnow.biz/videos/GlobalNow-Promo-48hrs-16x9.mp4","publisher":{"@type":"Organization","name":"globalnow.biz","url":"https://globalnow.biz","logo":{"@type":"ImageObject","url":"https://globalnow.biz/og-image.png"}}}</script>
<script type="application/ld+json">{"@context":"https://schema.org","@type":"VideoObject","name":"See Your Free Sample First — How It Works","description":"How GlobalNow builds your website: answer 5 quick questions, get a free sample built from your real Google reviews, and pay $0 until you approve it — $199 once you say yes.","thumbnailUrl":["https://globalnow.biz/img/globalnow-buildfree-poster.webp"],"uploadDate":"2026-09-17T12:00:00-04:00","duration":"PT33S","contentUrl":"https://globalnow.biz/videos/GlobalNow-Promo-BuildFree-16x9.mp4","publisher":{"@type":"Organization","name":"globalnow.biz","url":"https://globalnow.biz","logo":{"@type":"ImageObject","url":"https://globalnow.biz/og-image.png"}}}</script>
<script type="application/ld+json">{"@context":"https://schema.org","@type":"VideoObject","name":"Everything Included in Your $199 Website","description":"A walkthrough of everything included in a $199 GlobalNow website: custom pages written from real reviews, one-tap call buttons, a 24/7 AI answer bubble, a Google Business Profile tune-up, app-like install, and more — no monthly fees.","thumbnailUrl":["https://globalnow.biz/img/globalnow-included-poster.webp"],"uploadDate":"2026-09-17T12:00:00-04:00","duration":"PT1M5S","contentUrl":"https://globalnow.biz/videos/GlobalNow-Promo-Included-16x9.mp4","publisher":{"@type":"Organization","name":"globalnow.biz","url":"https://globalnow.biz","logo":{"@type":"ImageObject","url":"https://globalnow.biz/og-image.png"}}}</script>

`;
